import React from 'react';
// @ts-ignore
import variables from 'styles/_variables.scss';
import { IIconProps } from './IIconProps';

export const LoaderIcon = ({
	iconClass = '',
	title = '',
	color,
}: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 44 44"
			className={`icon ${iconClass}`}
		>
			{title && <title>{title}</title>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0V4C31.9411 4 40 12.0589 40 22C40 31.9411 31.9411 40 22 40C12.0589 40 4 31.9411 4 22H0C0 34.1503 9.84974 44 22 44Z"
				fill={color || variables.accentColor}
			/>
		</svg>
	);
};
